import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { CircularProgress, MuiThemeProvider } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import * as actions from 'components/TrustCenter/store/actions';
import { isBlank } from 'components/Common/Utils/StringUtils';
import { SPINNER_THEME } from 'components/TrustCenter/VisibilityConnection/ConnectionWizard/AddConnectionMUITheme';
import ClearIcon from '@material-ui/icons/Clear';
import * as Constants from 'constants/Constants';
import useDebounce from 'components/TrustCenter/UI/Debounce/Debounce';
import { PrimaryTextField } from 'theme/CommonTheme';

const GroupNameSearch = (props) => {
    const {
        groupName,
        getGroupNames,
        sendSelectedGroupName,
        groupNamesSuggestion,
        clearGroupNames,
        resetShipperGroupNameLoaded,
        isShipperGroupLoaded,
        currentAccountType,
        setRootError,
        isReadOnly
    } = props;

    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState([]);

    const [userInput, setUserInput] = useState('');

    const [userSearchShipperGroupName, setUserSearchShipperGroupName] = useState('');

    const debouncedSearchTerm = useDebounce(userSearchShipperGroupName, 1000);

    const [isError, setError] = useState(false);

    useEffect(() => {
        if (!open) {
            setOptions([]);
        }
    }, [open]);

    useEffect(() => {
        setUserInput(groupName);
    }, [groupName]);

    useEffect(() => {
        if (debouncedSearchTerm.length >= 3) {
            getGroupNames(debouncedSearchTerm);
        }
    }, [debouncedSearchTerm]);

    useEffect(() => {
        setRootError && setRootError(isError);
    }, [isError]);

    useEffect(() => {
        if (isShipperGroupLoaded) {
            let validOptions = [];
            if (currentAccountType.toLowerCase() !== Constants.ACCOUNT_TYPE_SHIPPER.toLowerCase()) {
                validOptions = groupNamesSuggestion;
            } else {
                validOptions = groupNamesSuggestion.filter((option) => {
                    return option !== Constants.SHIPPER_GROUP_NOT_APPLICABLE;
                });
            }
            setOptions([...validOptions]);
        }
    }, [isShipperGroupLoaded]);

    const handleInputChange = (event) => {
        clearGroupNames();
        resetShipperGroupNameLoaded();
        if (event.target.value.length >= 3) {
            setOpen(true);
            // getGroupNames(event.target.value);
            setUserSearchShipperGroupName(event.target.value);
        } else {
            setUserSearchShipperGroupName('');
            setOpen(false);
        }

        if (isBlank(event.target.value)) {
            setError(true);
        } else {
            setError(false);
        }
        setUserInput(event.target.value);
    };

    const handleSelectedOption = (selectedOption, reason) => {
        if (reason === 'select-option') {
            sendSelectedGroupName(selectedOption);
            setUserInput(selectedOption);
        } else {
            sendSelectedGroupName('');
        }
    };

    return (
        <Autocomplete
            id="group-name"
            open={open}
            onClose={(event, reason) => {
                if (reason !== 'blur') {
                    setOpen(false);
                    if (isBlank(userInput)) {
                        setError(true);
                    }
                }
            }}
            disabled={isReadOnly ?? false}
            inputValue={userInput}
            getOptionSelected={(option, value) => option === value}
            getOptionLabel={(option) => option}
            options={options}
            loading={!isShipperGroupLoaded}
            loadingText={
                <MuiThemeProvider theme={SPINNER_THEME}>
                    <CircularProgress />
                </MuiThemeProvider>
            }
            clearOnBlur={false}
            noOptionsText="(No Shipper Group found)"
            onChange={(event, selectedOption, reason) =>
                handleSelectedOption(selectedOption, reason)
            }
            size="small"
            closeIcon={
                <ClearIcon
                    onClick={() => {
                        setUserInput('');
                        setError(true);
                        setUserSearchShipperGroupName('');
                    }}
                    fontSize="small"
                />
            }
            renderInput={(params) => (
                <PrimaryTextField
                    {...params}
                    label="Group Name *"
                    error={isError}
                    helperText={
                        !isError
                            ? 'Enter 3 or more characters'
                            : 'Group Name' + Constants.IS_REQUIRED
                    }
                    onChange={(event) => handleInputChange(event)}
                />
            )}
        />
    );
};

const mapStateToProps = (state) => {
    return {
        groupNamesSuggestion: state.agreement.groupNames,
        isShipperGroupLoaded: state.agreement.isShipperGroupLoaded,
        currentAccountType: state.connection.currentAccountType
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getGroupNames: (input) => dispatch(actions.getGroupNames(input)),
        clearGroupNames: () => dispatch(actions.clearGroupNames()),
        resetShipperGroupNameLoaded: () => dispatch(actions.resetShipperGroupNameLoaded())
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(GroupNameSearch));
